import {
  Field,
  Text,
  LinkField,
  Link,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { Chatbot } from "@repo/nuance-chat";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import { Button } from "@repo/ui/button";
import * as Flex from "@repo/ui/flex";
import { SpinnerIcon } from "@/theme/icons/spinner";
import { useChatbotContext } from "../../../providers/chatbot-provider";
import { isMobile } from "../../../utils";
import styles from "./get-in-touch.module.css";

type ActionButtonsProps = ComponentProps & {
  fields: {
    data: {
      contextItem: {
        chatOnlineButton: Field<string>;
        myAccountButton: Field<string>;
        myAccountLink: LinkField;
      };
    };
  };
};

const ActionButtons = ({
  fields: {
    data: {
      contextItem: { myAccountButton, myAccountLink },
    },
  },
}: ActionButtonsProps) => {
  const {
    chatbotStatus,
    handleChatBotStatusChange,
    isChatbotActive,
    isChatbotLoading,
  } = useChatbotContext();

  const mobile = isMobile();

  return (
    <Flex.Container
      className={styles.actionButtonContainer}
      column={!!mobile}
      gap="lg"
    >
      {!isChatbotActive && (
        <Button
          className={clsx("typographyLabel3", styles.actionButton)}
          size="large"
          variant="primary"
          alignment="start"
          asChild
        >
          <Link field={myAccountLink || ""}>
            <Text field={myAccountButton} />
          </Link>
        </Button>
      )}
      {isChatbotLoading ? <SpinnerIcon label="Loading..." /> : null}
      <Chatbot
        onStatusChange={handleChatBotStatusChange}
        status={chatbotStatus}
      />
    </Flex.Container>
  );
};

export default ActionButtons;
